import { useEffect } from "react";
import { useUser } from "query/user.query";
import { useCatToolsStore } from "store/useCatToolsStore";

function CatToolsProvider() {
  const { data: user } = useUser();

  useEffect(() => {
    if (user) {
      useCatToolsStore.getState().loadCatTools();
    }
  }, [user]);

  return null;
}

export default CatToolsProvider;
